/* React hooks */
import {useEffect, useState} from "react";
/* Components */
import {useParams} from "react-router-dom";
import useData from "../../../hooks/useData";
import useAuth from "../../../hooks/useAuth";
import {updateRelationInfos} from "../../../api/admin/agencyReq";
import FormButtons from "../../../components/common/FormButtons";
import {checkRequiredFields, getErrorListFromValidation, removeErrorList} from "../../../helper/tools";
import Icon from "../../../components/common/Icon";

    export default function FormAgencyRelation({ legend, setShowModal, apiAgencyRelations }) {
        const { auth } = useAuth();
        const token = auth.token;
        const { id } = useParams();
        const {agencyRelation, networkList, ensembleList} = useData();

        const [values, setValues] = useState({});

        const onChange = (e) => {
            setValues({...values, [e.target.name]: e.target.value})
        };

        const handleSubmit = async (e) => {
            e.preventDefault()
            if (!checkRequiredFields()) {
                return;
            }
            let body = {
                agencyId: id,
                ensemble: values.ensemble?.id ? values.ensemble?.id : values.ensemble,
                network: values.network?.id ? values.network?.id : values.network
            }
            await updateRelationInfos(token, body)
                .then((response) => {
                    removeErrorList();
                    if(!response?.response?.data?.error) {
                        setShowModal(false)
                        apiAgencyRelations()
                    } else {
                        getErrorListFromValidation(response?.response?.data?.error)
                    }
                })
        }

        const handleRemoveModal = () => {
            setShowModal(false)
        };

        useEffect(() => {
            setValues(agencyRelation)
        }, [agencyRelation]);


    const networkOptionList = networkList?.map(network => (
        { [network?.id] : network?.name + (network?.enabled ? "" : " (inactif)") }
    ));

    const ensembleOptionList = ensembleList?.map(ensemble => (
        { [ensemble?.id] : [ensemble?.name] }
    ));

    return (
        <form onSubmit={handleSubmit} method="POST" noValidate>
            <fieldset>
                {(legend !== "no-legend") && <Icon source="fa-solid fa-building" span={legend}/>}
                { values?.isEnsemble != true &&
                    <div className="form-input">
                    <label htmlFor="ensemble">Ensemble</label>
                    <select name="ensemble" id="ensemble"
                            value={values?.ensemble?.id ? values?.ensemble?.id : values?.ensemble} onChange={onChange}>
                        <option value="">Sélectionnez un ensemble</option>
                        {ensembleOptionList.map(ensemble => (
                            <option key={Object.keys(ensemble)}
                                    value={Object.keys(ensemble)}>{Object.values(ensemble)}</option>
                        ))}
                    </select>
                </div>}
                <div className="form-input">
                    <label htmlFor="network">Réseau</label>
                    <select name="network" id="network"
                            value={values?.network?.id ? values?.network?.id : values?.network} onChange={onChange}>
                        <option value="">Sélectionnez un réseau</option>
                        {networkOptionList.map(network => (
                            <option key={Object.keys(network)}
                                    value={Object.keys(network)}>{Object.values(network)}</option>
                        ))}
                    </select>
                </div>
                <FormButtons handleRemoveModal={handleRemoveModal}/>
                <div className="errors"></div>
            </fieldset>
        </form>

    )
}
